export interface AchievementsServiceState {
  allow: boolean
  suppressionCount: number
}

export enum AchievementsActionTypes {
  SUPPRESS_ACHIEVEMENTS = 'suppress_achievements',
  ALLOW_ACHIEVEMENTS = 'allow_achievements'
}

export type AchievementsActions =
  | { type: AchievementsActionTypes.SUPPRESS_ACHIEVEMENTS }
  | { type: AchievementsActionTypes.ALLOW_ACHIEVEMENTS }
